<script>
import {mapState} from 'vuex'
export default {
    data() {
        return {
            active: '',
        }
    },

    props: ['section'],

    created() {
        this.active = this.section;
    },

    mounted() {
    },

    methods: {
    },
}
</script>
